// components/Loader.js
import React from "react";
import "./Loader.css"; 


const Loader = () => {
  return (
  <div className="loader-container">
      <div class="loader-wrapper">
      <span class="loader-letter">L</span>
      <span class="loader-letter">o</span>
      <span class="loader-letter">a</span>
      <span class="loader-letter">d</span>
      <span class="loader-letter">i</span>
      <span class="loader-letter">n</span>
      <span class="loader-letter">g</span>

      <div class="loader"></div>
    </div>
  </div>
  );
};

export default Loader;
